import { formatMask, MaskBlock } from 'utils/input-mask-util'
import { useCallback, useMemo } from 'react'

export interface InputMaskProps {
  value: string
  mask: MaskBlock[] | undefined
  onChange: (newValue: string) => unknown
}

export function useInputMask({ mask, value, onChange }: InputMaskProps) {
  const changeHandler = useCallback(
    (newValue: string) => {
      const masked = mask ? formatMask(mask, newValue) : newValue
      onChange?.(masked)
    },
    [mask, onChange],
  )

  const maskedValue = useMemo(
    () => (mask ? formatMask(mask, value) : value),
    [mask, value],
  )

  return {
    maskedValue,
    onChange: mask ? changeHandler : onChange,
  }
}
